import { ObjectResponseType } from '@pray/shared/utils/api/types/response';

import { GetCourseResponse } from './types';

export type GetCourseParams = {
  artistId: string;
  courseId: string;
};

export async function getCourse({ artistId, courseId }: GetCourseParams) {
  if (!courseId) throw new Error('Course ID is required');
  if (!artistId) throw new Error('Artist ID is required');

  const response: GetCourseResponse = {
    /* eslint-disable camelcase */
    responded_at: new Date().toISOString(),
    object: ObjectResponseType.OBJECT,
    data: {
      id: courseId,
      title: 'Sample Course Title',
      description: 'Sample course description text.',
      primary_image_url: 'https://picsum.photos/1400/1400',
    },
    /* eslint-enable camelcase */
  };

  // Uncomment when server implementation is ready
  // const url = `/studio/artists/${artistId}/courses/${courseId}`;
  // const response = await api.executeGetRequest<GetCourseResponse>(url);
  // return response.data;

  return response;
}
